import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { SWRConfig } from 'swr'
import { App } from './app'
import { AuthProvider } from './lib/auth'
import './styles.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <SWRConfig value={{ dedupingInterval: 2_000, errorRetryCount: 2, revalidateOnReconnect: true }}>
      <AuthProvider><App /></AuthProvider>
    </SWRConfig>
  </StrictMode>,
)

